// = Libs =
import React from 'react';

// = Styles =
import classes from './home.module.scss';

// = Imports =
import Page from '../../common/containers/page/page';
import Container from '@/common/containers/container/container';
import ListPreview from '@/pages/home/list-preview/list-preview';
import { OrgShort, useOrgList } from '@/services/organization.service';
import { mapToAuthorCard, mapToExecutorCard } from '@/services/poll.service';

function Home() {
  const orgs = useOrgList();
  return (
    <Page>
      <div className={classes.title}>
        <Container>
          <h1>Мониторинги данных</h1>
          <p>
            Собирая данные, мы помогаем Ленинградской области становиться лучше
          </p>
        </Container>
      </div>
      <Container>
        <div className={classes.preview}>
          <h2>Публичные опросы</h2>
          <ListPreview
            url={`/polls/public`}
            title={''}
            fetchConfig={{
              limit: 3,
              offset: 0,
              mode: 'public',
              mapping: mapToExecutorCard,
            }}
          />
        </div>
        <div className={classes.preview}>
          <h2>Опросы к заполнению</h2>
          {orgs?.executor?.map((org: OrgShort) => (
            <ListPreview
              url={`/polls/executor/${org.orgID}`}
              title={org.name}
              fetchConfig={{
                limit: 3,
                offset: 0,
                mode: 'executor',
                orgId: org.orgID,
                mapping: mapToExecutorCard,
              }}
            />
          ))}
        </div>
        <div className={classes.preview}>
          <h2>Созданные опросы</h2>
          {orgs?.author?.map((org: OrgShort) => (
            <ListPreview
              url={`/polls/author/${org.orgID}`}
              title={org.name}
              fetchConfig={{
                limit: 2,
                offset: 0,
                mode: 'author',
                orgId: org.orgID,
                mapping: mapToAuthorCard,
              }}
              forceMore
            />
          ))}
        </div>
      </Container>
    </Page>
  );
}

export default Home;
